import { Buffer } from "buffer";

// Polyfill Buffer for browser compatibility
if (!window.Buffer) window.Buffer = Buffer;
if (!globalThis.Buffer) globalThis.Buffer = Buffer;

import { initSentry } from "./lib/sentry";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry
initSentry();

createRoot(document.getElementById("root")!).render(<App />);
